
import { Outlet } from "react-router-dom";
const _Portafolio = () => {
    return (
        <>
            <Outlet />
        </>
    )
}
export default _Portafolio;